(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.k12DataManagement.name)
        .controller(schoolwork12.app.k12DataManagement.controllers.systemConfiguration, [
            '$rootScope', '$scope', '$timeout', '$http', '$uibModal', '$location', '$q', '$anchorScroll', '$state',
            schoolwork12.app.auth.services.authentication,
            schoolwork12.app.common.services.eventNotification,
            schoolwork12.app.k12DataManagement.services.k12DataManagementSvc,
            function ($rootScope, $scope, $timeout, $http, $uibModal, $location, $q, $anchorScroll, $state,
                authentication, eventNotification, k12DataManagementSvc) {

                console.info("In add school plan controller");
                $scope.forms = {};
                // $rootScope.hideK12DataMngmt = false;
                $scope.systemConfigErrorAlert = false;
                $scope.systemConfigSuccessAlter = false;
                $scope.systemConfigErrorMsg = ''
                $scope.systemConfigSaveBusy = false;
                $scope.tableIsRefreshing = false;
                $scope.createEditMode = false;
                $scope.systemConfigObject = null;

                //In case the user refresh the page and the endpoint is k12DataManagement/system-config, this will redirect him
                //back the the K12DataMagement main page
                if(typeof($scope.$parent.options) == 'undefined')
                    $state.go("k12DataManagement");

                //Error Messages Variables
                $scope.systemConfigNameRequired = schoolwork12.app.k12DataManagement.errorMessages.systemConfigNameRequired;
                $scope.systemConfigNameUnique = schoolwork12.app.k12DataManagement.errorMessages.systemConfigNameUnique;

                $scope.systemConfigGrid = {
                    enableFiltering: true,
                    enableGridMenu: true,
                    exporterMenuPdf: false,
                    paginationPageSizes: [25, 50, 75],
                    paginationPageSize: 10,
                    rowHeight: 100,
                    enableRowSelection: true,
                    data: [],
                    enableRowHeaderSelection: true,
                    columnDefs: [
                        {
                            field: 'name', displayName: 'Name', maxWidth: 500,
                            cellTemplate: '<div title="{{row.entity[col.field]}}" class="ui-grid-cell-contents" >' +
                                '<span ng-click="grid.appScope.showSystemConfigForm(row.entity)">' +
                                '<a>{{row.entity[col.field]}}</a>' +
                                '</span>' +
                                '</div>'
                        },
                        { 
                            field: 'value', displayName: 'Value', maxWidth: 700, cellClass: 'scrollableColumn', enableSorting: false, enableColumnMenu: false},
                        { field: 'notes', displayName: 'Notes', maxWidth: 700 , cellClass: 'scrollableColumn', enableSorting: false, enableColumnMenu: false},
                        { field: 'modifiedByName', displayName: 'Last Modified By', maxWidth: 150, enableColumnMenu: false},
                        { field: 'modifyDate', displayName: 'Last Modified Date', maxWidth: 150, enableColumnMenu: false },
                        { field: 'id', displayName: 'Action', maxWidth: 100, enableColumnMenu: false, enableFiltering: false, enableSorting: false,
                            cellTemplate: '<div title="Action" class="ui-grid-cell-contents actionIcons" style="position:relative; text-align: center">' +
                            '<span  style="float: none !important;" class="glyphicon glyphicon glyphicon-trash" ' +
                            'ng-click="grid.appScope.deleteSystemConfig(row.entity)" tooltip-placement="bottom" uib-tooltip="Delete System Configuration"> ' +
                            '</span>' +
                        '</div>'
                        }
                    ],
                    onRegisterApi: function (gridApi) {
                        $scope.gridApi = gridApi;
                    }
                };
                
                //get the System Configurations
                $scope.getSystemConfigurations = function () {
                    $scope.tableIsRefreshing = true;
                    k12DataManagementSvc.getSystemConfigs(authentication.getCurrentUser().keycode).then(function (data) {
                        if(data && data.length > 0){
                            $scope.systemConfigurations = data;
                            $scope.setSystemConfigs = angular.copy($scope.systemConfigurations);
                            $scope.systemConfigGrid.data = $scope.setSystemConfigs;
                            $scope.systemConfigErrorAlert = false;
                        }
                    }, function (errors) {
                        console.info('Error retrieving System Config list....'.concat(angular.toJson(errors)));
                        $scope.systemConfigErrorAlert = true;
                        $scope.systemConfigErrorMsg = '';
                        if (errors.data && errors.data._errors && errors.data._errors.length > 0) {
                            for (var j = 0; j < errors.data._errors.length; j++) {
                                $scope.systemConfigErrorMsg = $scope.systemConfigErrorMsg + errors.data._errors[j] + "\n";
                            }
                        } else if (errors.status == 401 || errors.status == 403) {
                            $scope.systemConfigErrorMsg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.systemConfigErrorMsg = schoolwork12.app.errorMessages.internalError;
                        }
    
                    })['finally'](function () {
                        $scope.$emit("isK12DataSaveBusy", false);
                        $scope.tableIsRefreshing = false;
                    });
                }

                $scope.deleteSystemConfig =  function (systemConfig) {
                    let systemConfigScope = $scope;
                    let systemConfigDeletionModal = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'systemConfigDeletion.html',
                        windowClass: 'alert-Modal',
                        keyboard: false,
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance2) {
                                //current Modal Scope
                                let systemConfigDeletionModalScope = $scope;
                                systemConfigDeletionModalScope.okDeleteSystemConfig = function () {
                                    $scope.systemConfigSaveBusy = true;
                                    let delSystemConfigPromise = k12DataManagementSvc.deleteSystemConfig(authentication.getCurrentUser().keycode, systemConfig);
                                    delSystemConfigPromise.then(function (data) {
                                        systemConfigScope.systemConfigErrorAlert = false;
                                        systemConfigScope.systemConfigSuccessAlter = true;
                                        systemConfigScope.getSystemConfigurations();
                                    }, function (errors) {
                                        console.info('Error deleting System Config....'.concat(angular.toJson(errors)));
                                        systemConfigScope.systemConfigErrorAlert = true;
                                        systemConfigScope.systemConfigErrorMsg = '';
                                        systemConfigScope.systemConfigSuccessAlter = false;
                                        if (errors.data && errors.data._errors && errors.data._errors.length > 0) {
                                            for (var j = 0; j < errors.data._errors.length; j++) {
                                                systemConfigScope.systemConfigErrorMsg = systemConfigScope.systemConfigErrorMsg + errors.data._errors[j] + "\n";
                                            }
                                        } else if (errors.status == 401 || errors.status == 403) {
                                            systemConfigScope.systemConfigErrorMsg = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            systemConfigScope.systemConfigErrorMsg = schoolwork12.app.errorMessages.internalError;
                                        }
                    
                                    })['finally'](function () {
                                        $uibModalInstance2.close(true);
                                        scope.systemConfigSaveBusy = false;
                                    });
                                };
    
                                systemConfigDeletionModalScope.systemConfigDeletionMsg = "You are about to delete system configuration " + systemConfig.name + ". Do you want to continue?";
    
                                systemConfigDeletionModalScope.cancelDeleteSystemConfig = function () {
                                    $uibModalInstance2.close(false);
                                };
    
                            }
                        ],
                    });
                }

                let resetSystemConfigFormErrors = function () {
                    $scope.systemConfigErrorAlert = false;
                    $scope.forms.systemConfig['configName'].$setValidity('nameRequired', true);
                    $scope.forms.systemConfig['configName'].$setValidity('nameUnique', true);
                }

                $scope.showSystemConfigForm = function (systemConfig = null) {
                    $scope.forms.systemConfig.$setPristine();
                    $scope.createEditMode = true;
                    if(systemConfig){
                        $scope.systemConfigFormType = "Edit";
                        $scope.systemConfigObject = angular.copy(systemConfig);
                    }else{
                        $scope.systemConfigFormType = "Create";
                        $scope.systemConfigObject = {
                            name: "",
                            value: "",
                            notes: ""
                        };
                    }
                }

                $scope.cancelSystemConfigForm = function () {
                    if($scope.forms.systemConfig.$dirty){
                        SystemConfigFormUnsavedChanges()
                    }else{
                        $scope.createEditMode = false;
                        resetSystemConfigFormErrors();
                    } 
                }

                let SystemConfigFormUnsavedChanges = function (params) {
                    let systemConfigScope = $scope;
                    let systemConfigUnsavedChangesModal = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'systemConfigUnsavedChanges.html',
                        windowClass: 'alert-Modal',
                        keyboard: false,
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance2) {
                                //current Modal Scope
                                let systemConfigUnsavedModalScope = $scope;
                                systemConfigUnsavedModalScope.discardSystemConfigChanges = function () {
                                    resetSystemConfigFormErrors()
                                    systemConfigScope.createEditMode = false;
                                    $uibModalInstance2.close(true);
                                };
    
                                systemConfigUnsavedModalScope.systemConfigUnsavedChangesMsg = "Your system configuration has not been saved. Do you want to cancel without saving?";
    
                                systemConfigUnsavedModalScope.stayInSystemConfigForm = function () {
                                    $uibModalInstance2.close(false);
                                };
    
                            }
                        ],
                    });
                }

                let validateSystemConfigForm = function () {
                    let result = true;
                    resetSystemConfigFormErrors();

                    if($scope.systemConfigObject.name == null || $scope.systemConfigObject.name.trim() == ''){
                        $scope.forms.systemConfig['configName'].$setValidity('nameRequired', false);
                        result = false;
                    }
                    return result;
                }

                $scope.saveSystemConfig = function () {
                    if(validateSystemConfigForm()){
                        $scope.systemConfigSaveBusy = true;
                        let saveSystemConfigPromise = k12DataManagementSvc.saveSystemConfig(authentication.getCurrentUser().keycode,$scope.systemConfigObject);
                        saveSystemConfigPromise.then(function (data) {
                            $scope.systemConfigErrorAlert = false;
                            $scope.systemConfigSuccessAlter = true;
                            $scope.getSystemConfigurations();
                            $scope.createEditMode = false;
                        }, function (errors) {
                            console.info('Error Saving System Config....'.concat(angular.toJson(errors)));
                            $scope.systemConfigErrorAlert = true;
                            $scope.systemConfigErrorMsg = '';
                            $scope.systemConfigSuccessAlter = false;
                            if(errors.status == 400){
                                if (errors.data && errors.data._errors && errors.data._errors.length > 0) {
                                    for (var j = 0; j < errors.data._errors.length; j++) {
                                        $scope.systemConfigErrorMsg = $scope.systemConfigErrorMsg + errors.data._errors[j] + "\n";
                                    }
                                } 
                                let isDuplicatedName = (~$scope.systemConfigErrorMsg.indexOf("Name is already in use by another system configuration. Please enter a unique Name."));
                                $scope.forms.systemConfig['configName'].$setValidity('nameUnique', !isDuplicatedName);
                            }else if (errors.status == 401 || errors.status == 403) {
                                $scope.systemConfigErrorMsg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.systemConfigErrorMsg = schoolwork12.app.errorMessages.internalError;
                            }
        
                        })['finally'](function () {
                            $scope.systemConfigSaveBusy = false;
                        });
                    }
                }

            }]);


}(angular, schoolwork12));